module.exports = __webpack_public_path__ + "img/logo-primary.553605cd.svg";